import { Container } from "@mui/material"
import { Outlet } from "react-router-dom"
import PublicAppBar from "../appbar/PublicAppBar"
import IdleTimeCount from "../common/IdleTimeCount"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import { fetchAllMasterData } from "../../redux/slices/masterDataSlice"

const PublicLayout = () => {
  const dispatch = useAppDispatch()
  const { isLoggedIn } = useAppSelector((state) => state.user)

  useEffect(() => {
    if (!isLoggedIn) return
    dispatch(fetchAllMasterData())
  }, [isLoggedIn])

  return (
    <>
      <Container maxWidth="lg">
        <IdleTimeCount />
        <PublicAppBar />
        <Outlet />
      </Container>
    </>
  )
}

export default PublicLayout
